import { IReportingEntityWithDeliveryDates } from "../types";

export const currentDeliveryDate = (reportingEntity: IReportingEntityWithDeliveryDates): Date | null => reportingEntity?.ForecastDate || reportingEntity?.BaselineDate;